/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientModel } from '../../models/patient-model';

export interface PatientClinicGroupIdPost$Params {
  clinicGroupId: string;
      body?: PatientModel
}

export function patientClinicGroupIdPost(http: HttpClient, rootUrl: string, params: PatientClinicGroupIdPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientModel>> {
  const rb = new RequestBuilder(rootUrl, patientClinicGroupIdPost.PATH, 'post');
  if (params) {
    rb.path('clinicGroupId', params.clinicGroupId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<PatientModel>;
    })
  );
}

patientClinicGroupIdPost.PATH = '/Patient/{clinicGroupId}';
